<template>
	<page>
		<module enable-flex>
			<m-operate>
				<c-button v-if="auth('b_digital_config')" v-lock="lock('b_digital_config')" color="main" prepend-icon="tf-add" @click="createHandle">创建数据看板</c-button>
			</m-operate>

			<c-table ref="list" height="grow" :paging="false">
                <c-table-column
                    label="菜单名称"
                    name="name"
                    width="160"
                ></c-table-column>

				<c-table-column
					label="看板标题名称"
					name="title"
					width="200"
				></c-table-column>

				<c-table-column
					label="权限"
					name="auth_names"
					width="300"
				>
					<template #default="{data}">
						<c-tags v-if="data.auth_names" :value="data.auth_names.split(',')"></c-tags>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="80"
				>
					<template #default="{data}">
						<c-switch v-if="auth('b_digital_config')" v-model="data.state" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
						<c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="185"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_digital_config')" v-lock="lock('b_digital_config')" icon="tf-edit" @click="navigateTo(`/kanban/manage/config/${data.id}`)">编辑</c-table-button>
						<c-table-button v-if="auth('b_digital_config')" v-lock="lock('b_digital_config')" icon="tf-trash" @click="deleteHandle(data)">删除</c-table-button>
						<c-table-button v-if="auth('b_digital_config')" v-lock="lock('b_digital_config')" icon="tf-auth" @click="authConfig(data)">设置权限</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>

		<c-dialog ref="authConfig" title="设置权限" width="600" @resolve="authConfigHandle">
			<c-form ref="authForm" unit-width="100%">
				<c-input type="hidden" name="id"></c-input>
				<c-form-item label="可见部门">
					<c-select ref="departmentSelector" class="flex-grow" name="department_ids" async :multiple="{linefeed: true}" @search="searchDepartment"></c-select>
				</c-form-item>
				<c-form-item label="可见用户" tip="可见部门和可见用户都不选择表示所有人可见">
					<c-select ref="userSelector" class="flex-grow" name="user_ids" async :multiple="{linefeed: true}" @search="searchUser"></c-select>
				</c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		data() {
			return {
			}
		},

		computed: {
		},

		mounted() {
			this.update();
		},

		methods: {
			update() {
				this.$refs.list.load({
					url: '/digital/list'
				})
			},

			createHandle() {
				if (this.$refs.list.getData().length >= 10) {
					this.$message({
						message: '最多只能创建10个数据看板'
					});
					return;
				}
				this.navigateTo('/kanban/manage/config/new');
			},

			stateHandle(state, next, data) {
				this.request({
					url: '/digital/edit/state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					success: () => {
						next();
						this.$store.dispatch('updateLoginInfo');
					}
				})
			},

			deleteHandle(data) {
				this.$confirm({
					title: `确认要删除看板【${data.title}】`,
					message: '删除后不可恢复',
					resolve: () => {
						this.request({
							url: '/digital/remove',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功'
								});
								this.$refs.list.update();
								this.$store.dispatch('updateLoginInfo');
							}
						});
					}
				});
			},

			authConfig(item) {
				this.request({
					url: '/digital/auth/detail',
					data: {
						id: item.id
					},
					loading: true,
					success: data => {
						this.$refs.authForm.set({
							id: item.id
						});
						this.$refs.departmentSelector.setValueData(data.department_list);
						this.$refs.userSelector.setValueData(data.user_list);
						this.$refs.authConfig.open();
					}
				});
			},

			authConfigHandle(stop, next) {
				stop();
				this.$refs.authForm.submit({
					url: '/digital/edit/auth',
					success: () => {
						next();
						this.$message({
							message: '设置成功'
						});
						this.$refs.list.update();
						this.$store.dispatch('updateLoginInfo');
					}
				});
			},

			searchDepartment(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'DEPARTMENT',
						keyword
					},
					success: data => {
						resolve(data);
					}
				})
			},

			searchUser(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'SYSUSER',
						keyword
					},
					success: data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>